module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "wd-dialog-wrapper",
    on: {
      "click": _vm.onMaskClose
    }
  }, [_c('div', {
    staticClass: "wd-dialog"
  }, [_c('div', {
    ref: "copyContent",
    staticClass: "wd-dialog__body"
  }, [_vm._t("mainContent"), _vm._v(" "), _vm._t("content")], 2), _vm._v(" "), _c('div', {
    ref: "copyButton",
    staticClass: "wd-dialog__footer"
  }, [_c('button', {
    staticClass: "wd-button wd-button-copy",
    on: {
      "click": _vm.onCopyClick
    }
  }, [_vm._v("复制到剪贴板")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0903a86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fx-share.vue
// module id = 620
// module chunks = 1